/** Gets Table **body** column count by table head column definitions. */
export function getTableBodyColumnCount(headColumns) {
    return headColumns.reduce((sum, currentValue) => sum + (currentValue.span ?? 1), 0);
}
